export const LOGIN = 'LOGIN'

export const LOGOUT = 'LOGOUT'

export const STORE_MESSAGES = 'STORE_MESSAGES'

export const STORE_NOTIFICATION = 'STORE_NOTIFICATION'
